import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { APP_LOGO, APP_NAME } from 'api/Keys';

// third party style
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import './styles/theme-base.css';

const applyBranding = () => {
  if (APP_NAME) {
    document.title = APP_NAME;
  }

  if (APP_LOGO) {
    const selectors = ["link[rel='icon']", "link[rel='shortcut icon']"];
    selectors.forEach((selector) => {
      const link = document.querySelector(selector);
      if (link) {
        link.setAttribute('href', APP_LOGO);
      }
    });
  }
};

applyBranding();

const root = createRoot(document.getElementById('root'));

root.render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StyledEngineProvider>
);

// for IE-11 support un-comment cssVars() and it's import in this file
// and in MatxTheme file

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
